import { Link } from '@nimbus-ds/components';
import { PaymentProviderDto } from '@tiendanube/common';
import { Stack } from 'commons/components';
import { useProvidersActionsItems } from 'domains/Payments/PaymentProviders/hooks';
import { OnPaymentProviderActionType } from '../../PaymentProviderActionModal';

interface PaymentProviderProps {
  paymentProvider: PaymentProviderDto;
  onAction: OnPaymentProviderActionType;
}

export function ProvidersActions({
  paymentProvider,
  onAction,
}: Readonly<PaymentProviderProps>) {
  const { getLeftLink, getRightLink, handleGoToMainPage } =
    useProvidersActionsItems({ paymentProvider, onAction });

  return (
    <Stack justify="space-between">
      <Stack>
        <Link
          onClick={handleGoToMainPage}
          appearance="primary"
          textDecoration="none"
        >
          {getLeftLink()}
        </Link>
      </Stack>
      <Stack>{getRightLink()}</Stack>
    </Stack>
  );
}
